import moment from 'moment-timezone'
import SessionHelper from '@/helpers/SessionHelper'
import Report from '@/api/Report'

/**
 * Piezas comunes a las cuatro vistas de reportes: filtros de laboratorio y
 * distribuidora, la ventana de fechas, y los formateadores de celda.
 *
 * Se factoriza como mixin porque las cuatro vistas cargan los mismos catálogos
 * y arman el mismo querystring; sin esto, cada una repetiría ~60 líneas
 * idénticas y se irían desincronizando con el tiempo.
 *
 * Las vistas que no usan fechas (cartera, vencimientos) simplemente no llaman a
 * `startDate`/`endDate`: `params()` omite lo que esté vacío.
 */
export default {
  data() {
    return {
      labId: null,
      distId: null,
      startMenu: false,
      endMenu: false,
      // Por defecto, los últimos 12 meses cerrados.
      startDate: moment()
        .subtract(11, 'months')
        .startOf('month')
        .format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      laboratorioItems: [],
      distribuidorItems: [],
    }
  },

  computed: {
    isDistributor() {
      return SessionHelper.role === 'DIST'
    },
  },
  methods: {
    /** Carga los catálogos que alimentan los selectores de filtro. */
    loadCatalogos() {
      if (this.isDistributor) {
        return Report.getFilters().then(response => {
          const data = response && response.data
          this.laboratorioItems = ((data && data.laboratories) || []).map(
            l => ({ text: l.name, value: l.id })
          )
          this.distribuidorItems = ((data && data.distributors) || []).map(
            d => ({ text: d.name, value: d.id })
          )
        })
      }
      this.$store.dispatch('laboratories/getAll', {}).then(response => {
        this.laboratorioItems = ((response && response.items) || []).map(l => ({
          text: l.name,
          value: l.id,
        }))
      })
      this.$store.dispatch('distributors/getAll', {}).then(response => {
        this.distribuidorItems = ((response && response.items) || []).map(
          d => ({
            text: d.name,
            value: d.id,
          })
        )
      })
    },

    /**
     * Arma los parámetros del reporte omitiendo los filtros vacíos, para no
     * mandar `labId=null` al backend.
     * @param {Object} extra Parámetros propios de la vista
     * @return {Object} Querystring params
     */
    params(extra) {
      const params = { ...(extra || {}) }
      if (this.labId) params.labId = this.labId
      if (this.distId && !this.isDistributor) params.distId = this.distId
      if (this.isDistributor) delete params.distId
      return params
    },

    /** Igual que `params`, más la ventana de fechas de la vista. */
    paramsConFechas(extra) {
      return this.params({
        startDate: this.startDate,
        endDate: this.endDate,
        ...(extra || {}),
      })
    },

    /** Números: em dash cuando no hay dato, para no mostrar un 0 engañoso. */
    format(value) {
      return value === null || value === undefined ? '—' : value
    },

    /** Montos en formato panameño abreviado; el detalle exacto va al Excel. */
    money(value) {
      if (value === null || value === undefined) return '—'
      const n = Number(value)
      if (Math.abs(n) >= 1000000) return `B/. ${(n / 1000000).toFixed(1)}M`
      if (Math.abs(n) >= 1000) return `B/. ${(n / 1000).toFixed(0)}K`
      return `B/. ${n.toFixed(2)}`
    },

    /** Fechas cortas y estables, sin depender del locale del navegador. */
    date(value) {
      return value ? moment(value).format('DD/MM/YYYY') : '—'
    },
  },
}
